// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auto-position-box_bd57d618 {
  position: absolute;
  top: 0;
  left: 0;
}
.auto-position-box__container_bd57d618 {
  position: relative;
  z-index: var(--auto-position-box-z-index, 60);
}
.auto-position-box__container_bd57d618 > :first-child {
  position: static;
}
.auto-position-box__container_absolute_bd57d618 {
  position: absolute;
  z-index: var(--auto-position-box-z-index, 90);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"auto-position-box": `auto-position-box_bd57d618`,
	"auto-position-box__container": `auto-position-box__container_bd57d618`,
	"auto-position-box__container_absolute": `auto-position-box__container_absolute_bd57d618`
};
export default ___CSS_LOADER_EXPORT___;
